define(['layout/util/layout'], function (layout) {
    'use strict';

    function patchExpandableMenu(id, patchers) {
        patchers.css(id, {height: ''});
    }

    layout.registerPatcher('wysiwyg.viewer.components.ExpandableMenu', patchExpandableMenu);
});
